"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var paths = {
    zent: "https://cdn.izettle.com/fonts/zent/v1101",
    tiemposHeadline: "https://cdn.izettle.com/web-brand/fonts/tiempos-headline/v1"
};
exports.default = {
    zent: {
        name: "Zent",
        fallbacks: ["Arial", "sans-serif"],
        fonts: {
            light: {
                weight: 300,
                file: paths.zent + "/Zent-Light.woff"
            },
            regular: {
                weight: 400,
                file: paths.zent + "/Zent-Regular.woff"
            },
            medium: {
                weight: 500,
                file: paths.zent + "/Zent-Medium.woff"
            },
            semiBold: {
                weight: 600,
                file: paths.zent + "/Zent-SemiBold.woff"
            },
            bold: {
                weight: 700,
                file: paths.zent + "/Zent-Bold.woff"
            },
            extraBold: {
                weight: 900,
                file: paths.zent + "/Zent-ExtraBold.woff"
            }
        }
    },
    tiempos: {
        name: "Tiempos-Headline",
        fallbacks: ["Georgia", "serif"],
        fonts: {
            "semi-bold": {
                weight: "normal",
                file: paths.tiemposHeadline + "/TiemposHeadline-SemiBold.woff"
            }
        }
    }
};
